module.exports = __webpack_public_path__ + "static/media/real-time-alerts.01e087df.svg";